export default "__VITE_ASSET__C9HWNn2c__"